import { CdnService } from '@/common/services/cdn/cdn.service';
import { TermsConditionsResponse } from '@/core/domain/terms-conditions/models/terms-conditions.model';
import { TermsConditionsRepository } from '@/core/domain/terms-conditions/repositories/terms-conditions.repository';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TermsConditionsImplRepository extends TermsConditionsRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }

    override getTermsConditions(): Observable<TermsConditionsResponse> {
        return this.http.get<TermsConditionsResponse>(
            CdnService.url(
                'terms-conditions-json/' +
                    this.getLanguageUseCase.execute().language +
                    '.json',
            ),
        );
    }
}
